import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import ArticleCard from "@/components/feature/ArticleCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import HotSidebar from "@/pages/home/components/HotSidebar";
import TopicShowcase from "@/pages/home/components/TopicShowcase";
import { hotArticles, latestArticles } from "@/utils/news";

export default function Home() {
  const slides = latestArticles(5);
  const feed = latestArticles(9).slice(1);
  const ranking = hotArticles(6);

  return (
    <div>
      <Seo
        title="51爆料 - 最新热点新闻与内幕爆料平台"
        description="51爆料提供最新的热点新闻、内幕爆料及深度报道，涵盖社会、娱乐、科技等多个领域，帮助用户及时掌握真实信息和多元视角。"
        keywords="51爆料,热点新闻,内幕爆料,最新资讯,社会新闻,娱乐爆料,科技新闻,深度报道"
      />

      <HeroCarousel slides={slides} />

      <CategoryEntry />

      <section className="max-w-7xl mx-auto w-full px-4 md:px-6 pb-4">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8">
          <div>
            <div className="flex items-end justify-between mb-5">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-black text-foreground-950">
                  最新爆料
                </h2>
                <p className="text-sm text-foreground-500 mt-1">
                  实时更新，抢先看到正在发生的事
                </p>
              </div>
              <Link
                to="/category/all"
                className="text-sm text-primary-600 hover:text-primary-700 inline-flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                更多爆料
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="flex flex-col gap-4">
              {feed.map((article) => (
                <ArticleCard key={article.id} article={article} layout="row" />
              ))}
            </div>
          </div>

          <HotSidebar ranking={ranking} />
        </div>
      </section>

      <TopicShowcase />

      <section className="max-w-7xl mx-auto w-full px-4 md:px-6 py-12 md:py-16">
        <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-10 grid grid-cols-1 md:grid-cols-[auto_1fr] gap-6 md:gap-10 items-center">
          <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 text-3xl md:text-4xl">
            <i className="ri-flashlight-fill" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-black text-foreground-950">
              关于 51爆料
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              51爆料是一家聚焦社会热点、娱乐八卦、科技前沿的资讯爆料平台。我们坚持以事实为底线、以多元为视角，为追求及时、真实、全面信息的用户，梳理每一个热点事件背后的脉络。
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6">
              {[
                { num: "3+", label: "核心频道" },
                { num: "24h", label: "热点追踪" },
                { num: "100+", label: "深度报道" },
                { num: "50万+", label: "月浏览人次" },
              ].map((s) => (
                <div key={s.label}>
                  <p className="text-lg md:text-2xl font-heading font-black text-primary-600">
                    {s.num}
                  </p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 mt-6 px-4 py-2 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}